<template>
  <section class="section projects-teaser">
    <h2>Our Latest Projects</h2>
    <!-- <p class="projects-teaser__subtitle">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
      sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
      Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
    </p> -->
    <ul class="projects-teaser__list">
      <li class="projects-teaser__list--item" v-for="project in projects" v-bind:key="project.id">
        <router-link to="/">
          <img class="projects-teaser__list--item-image" :src="project.image" alt="Project teaser image">
          <div class="projects-teaser__list--item-content">
            <svg viewBox="0 0 14 11" fill="none">
              <path d="M1 5.5H13M13 5.5L7 1M13 5.5L7 10" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <h4>{{project.title}}</h4>
          </div>
        </router-link>
      </li>
    </ul>
  </section>
</template>

<script>
/* eslint-disable global-require */
export default {
  name: 'projects-teaser',
  data: () => ({
    projects: [
      {
        id: 'project-1',
        image: require('../../assets/img/solar_house.jpg'),
        title: 'Smart Energy House at Landesstelle',
      },
      {
        id: 'project-2',
        image: require('../../assets/img/solar_mountains.jpg'),
        title: 'SRH Solar Summer Team-up!',
      },
      {
        id: 'project-3',
        image: require('../../assets/img/building.jpg'),
        title: 'Solar Winter School at SRH',
      },
    ],
  }),
  methods: {
  },
};
</script>
